import React, { useEffect } from "react";
import "./styles.css";
import { useNavigate } from "react-router-dom";
import GooglePlayBadge from "../../assets/images/googleplay-badge.png";
import PhilosophySection from "../ourPhilosophy";

const MainContent = () => {
  const navigate = useNavigate();

  const showPhilosophy = () => {
    const section = document.getElementById("philosophy");
    if (!section) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    section.scrollIntoView({
      behavior: reduceMotion ? "auto" : "smooth",
      block: "start",
    });
    section.focus({ preventScroll: true });
  };

  useEffect(() => {
    if (window.location.hash !== "#philosophy") return;
    document.getElementById("philosophy")?.scrollIntoView({ block: "start" });
  }, []);

  return (
    <main className="muscle-home">
      <section className="home-hero">
      <div className="home-coming-soon">
        <span className="coming-soon-title">COMING SOON</span>
        <span className="coming-soon-date">DEC 15, 2026</span>
      </div>
      <div className="home-layout">
        <div className="home-content">
          <button
            type="button"
            className="home-philosophy-button"
            onClick={showPhilosophy}
          >
            Our Philosophy
            <span aria-hidden="true">↓</span>
          </button>
          <div className="home-eyebrow">
            <span className="home-dot" />
            BUILT FOR THE LONG GAME
          </div>

          <h1 className="home-title">
            TRAIN.
            <br />
            TRACK.
            <br />
            <span>GET STRONGER.</span>
          </h1>

          <p className="home-description">Less noise. More training.</p>

          <a
            className="home-play-store disabled"
            href="https://play.google.com/store"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={GooglePlayBadge} alt="Get it on Google Play" />
          </a>
        </div>

        <div className="home-visual" aria-hidden="true">
          <div className="home-orbit home-orbit-outer" />
          <div className="home-orbit home-orbit-middle" />
          <div className="home-orbit home-orbit-inner" />

          <div className="home-visual-center">
            <div className="home-visual-center">
              <span className="home-letter-m">M</span>
              <span className="home-letter-u">U</span>
            </div>
            <span className="home-visual-period">.</span>
          </div>

          <span className="home-orbit-point home-orbit-point-one" />
          <span className="home-orbit-point home-orbit-point-two" />

          <div className="home-visual-caption">
            <span className="home-dot" />
            PROGRESS OVER PERFECTION
          </div>
        </div>
      </div>
      </section>

      <PhilosophySection />

      <nav className="home-links" aria-label="Site links">
        <button onClick={() => navigate("/muscleUp/privacy-policy")}>
          Privacy Policy <span aria-hidden="true">↗</span>
        </button>

        <span className="home-link-divider" />

        <button onClick={() => navigate("/muscleUp/terms-and-conditions")}>
          Terms &amp; Conditions <span aria-hidden="true">↗</span>
        </button>
      </nav>
    </main>
  );
};

export default MainContent;
